var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle107(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "123.26295888424465 305.7507777004582 30.11611368807897 29.944412946424166",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M139.23,311.12c.72-.44,1.53-1.29,2.4-1.36.91-.08,2.07.37,2.8.98,2.67,2.24,4.45,5.11,4.89,8.59.67,5.32-4.47,11.68-9.8,12.3-1.64.19-3.2-.03-4.72-.73-2.04-.94-3.8-2.24-5.25-3.92-4.61-5.37-1.9-14.15,4.99-15.91,1.46-.37,3.12.01,4.7.05ZM140.89,313.61c-.54.74-.94,1.52-1.56,2.05-.76.65-1.78,1.01-2.55,1.65-1.11.92-2.27,1.87-3.1,3.03-1.56,2.16-1.15,4.51.86,6.25,2.52,2.18,5.52,1.98,7.76-.54,1.78-2.01,2.47-4.31,1.56-6.9-.67-1.92-1.38-3.85-2.97-5.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle107);
export default __webpack_public_path__ + "static/media/twinkle-1-07.8dbd2b104d0c39a0170d03f86079a1e6.svg";
export { ForwardRef as ReactComponent };